const COMPACT_MONEY = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  notation: "compact",
  maximumFractionDigits: 1,
});

const COUNT = new Intl.NumberFormat("en-IN");

const RUPEES = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

/**
 * `₹2,98,412` — whole rupees, exact: what a tooltip or a legend says, where
 * `₹3L` would hide the difference between two slices (#639).
 */
export function formatRupees(rupees: number): string {
  return RUPEES.format(rupees);
}

/** `₹1.2L` on an axis tick: full paise would crowd the margin. */
export function formatCompactMoney(rupees: number): string {
  return COMPACT_MONEY.format(rupees);
}

/** `1,234` — a count, grouped the way the rest of the app groups money. */
export function formatCount(value: number): string {
  return COUNT.format(value);
}
